import appannie from '@/pages/intelligence/assets/svg/dataSource/appannie.svg';
import sensorTower from '@/pages/intelligence/assets/svg/dataSource/sensor-tower.svg';
import databrainCalibrated from '@/pages/intelligence/assets/svg/dataSource/databrain-blue-bg.svg';
import NPD from '@/pages/intelligence/assets/svg/dataSource/npd-icon.svg';
import appStore from '@/pages/intelligence/assets/svg/dataSource/appstore.svg';
import googleplay from '@/pages/intelligence/assets/svg/dataSource/googleplay.svg';
import steam from '@/pages/intelligence/assets/svg/dataSource/steam.svg';
import epic from '@/pages/intelligence/assets/svg/dataSource/epic.svg';
import xbox from '@/pages/intelligence/assets/svg/dataSource/xbox.svg';
import hatchet from '@/pages/intelligence/assets/svg/dataSource/hatchet.svg';
import mSci from '@/pages/intelligence/assets/svg/dataSource/mscience.svg';
import nintendo from '@/pages/intelligence/assets/svg/dataSource/nintendo.svg';
import youtube from '@/pages/intelligence/assets/svg/dataSource/youtube.svg';
import crunchbase from '@/pages/intelligence/assets/svg/dataSource/crunchbase.svg';
import playstation from '@/pages/intelligence/assets/svg/dataSource/playstation.svg';
import twitch from '@/pages/intelligence/assets/svg/dataSource/twitch.svg';
import fbGaming from '@/pages/intelligence/assets/svg/dataSource/fbgaming-bg.svg';
import gsd from '@/pages/intelligence/assets/svg/dataSource/gsd-icon.svg';
import alinea from '@/pages/intelligence/assets/svg/dataSource/alinea.svg';
import ampere from '@/pages/intelligence/assets/svg/dataSource/ampere.svg';

export const summaryItem = {
  mobileGame: {
    icon: 'other-icon',
    nameEn: 'Mobile Games',
    nameZh: '手游总量',
    num: 0,
  },
  pcGame: {
    icon: 'monitor',
    nameEn: 'PC Games',
    nameZh: '端游总量',
    num: 0,
  },
  consoleGame: {
    icon: 'game',
    nameEn: 'Console Games',
    nameZh: '主机总量',
    num: 0,
  },
  dataSource: {
    icon: 'camera',
    nameEn: 'Data sources',
    nameZh: '商业数据源',
    num: 0,
  },
  crawlers: {
    icon: 'crawlers-icon',
    nameEn: 'Crawlers',
    nameZh: '爬虫数据源',
    num: 0,
  },
  companies: {
    icon: 'companies-icon',
    nameEn: 'Companies',
    nameZh: '公司总量',
    num: 0,
  },
  countries: {
    icon: 'chart-map',
    nameEn: 'Countries',
    nameZh: '国家覆盖',
    num: 0,
  },
  news: {
    icon: 'material',
    nameEn: 'News',
    nameZh: '新闻总量',
    num: 0,
  },
  options: {
    icon: 'clipboard-m',
    nameEn: 'Opinions',
    nameZh: '社会舆情总量',
    num: 0,
  },
  comments: {
    icon: 'information',
    nameEn: 'Comments',
    nameZh: '游戏商店评论',
    num: 0,
  },
};

// 数据源列表：顺序/中英 hover 文案/跳转路径以 TAPD #1120427644135228125 需求表为权威，
// 与首页 home 子仓 homeDataSources 保持一致。跳转用站内相对路径，天然适配 woa/global 环境。
export const dataSourceList = [
  {
    icon: sensorTower,
    nameEn: 'Sensor Tower',
    hoverZh: '数据来源：Sensor Tower\n点击查看排行榜-手游',
    hoverEn: 'Data Source: Sensor Tower\nClick to view Top Charts-Mobile',
    sourceUrl:
      '/intelligence/topCharts/mobileGames?chart_type=bar&source=sensortower&sort_name=dau&ratio_type=0&order=desc',
  },
  {
    icon: databrainCalibrated,
    nameEn: 'Databrain Calibrated Data',
    hoverZh: '数据来源：Databrain 校准数据\n点击查看排行榜-端游 & 主机游戏',
    hoverEn: 'Data Source: Databrain Calibrated Data\nClick to view Top Charts-PC&Console',
    sourceUrl: '/intelligence/topCharts/pcConsoleGames/DataBrainCalibration',
  },
  {
    icon: mSci,
    nameEn: 'MScience',
    hoverZh: '数据来源：Mscience\n点击查看排行榜-端游 & 主机游戏',
    hoverEn: 'Data Source: Mscience\nClick to view Top Charts-PC&Console',
    sourceUrl: '/intelligence/topCharts/pcConsoleGames/MetricsTable',
  },
  {
    icon: alinea,
    nameEn: 'Alinea Analytics',
    hoverZh: '数据来源：Alinea Analytics\n点击查看排行榜-端游 & 主机游戏',
    hoverEn: 'Data Source: Alinea Analytics\nClick to view Top Charts-PC&Console',
    sourceUrl: '/intelligence/topCharts/pcConsoleGames/MetricsTable',
  },
  {
    icon: appStore,
    nameEn: 'iOS App Store',
    hoverZh: '数据来源：iOS App Store\n点击查看商店排行-手游全球/地区',
    hoverEn: 'Data Source: iOS App Store\nClick to view Store Ranks-Mobile Global/Region',
    sourceUrl: '/intelligence/storeRanks/MobileGlobalRegion/AllTopCharts',
  },
  {
    icon: googleplay,
    nameEn: 'Google Play',
    hoverZh: '数据来源：Google Play\n点击查看商店排行-手游全球/地区',
    hoverEn: 'Data Source: Google Play\nClick to view Store Ranks-Mobile Global/Region',
    sourceUrl: '/intelligence/storeRanks/MobileGlobalRegion/AllTopCharts',
  },
  {
    icon: steam,
    nameEn: 'Steam',
    hoverZh: '数据来源：Steam\n点击查看商店排行-PC游戏全球',
    hoverEn: 'Data Source: Steam\nClick to view Store Ranks-PC Global',
    sourceUrl: '/intelligence/storeRanks/PCGlobal/steam',
  },
  {
    icon: gsd,
    nameEn: 'GSD',
    hoverZh: '数据来源：GSD\n点击查看排行榜-端游 & 主机游戏',
    hoverEn: 'Data Source: GSD\nClick to view Top Charts-PC&Console',
    sourceUrl: '/intelligence/topCharts/pcConsoleGames/MetricsTable',
  },
  {
    icon: xbox,
    nameEn: 'Xbox',
    hoverZh: '数据来源：Xbox\n点击查看商店排行-主机游戏地区',
    hoverEn: 'Data Source: Xbox\nClick to view Store Ranks-Console Region',
    sourceUrl: '/intelligence/storeRanks/ConsoleRegion/xbox',
  },
  {
    icon: ampere,
    nameEn: 'Other Vendors',
    hoverZh: '数据来源：Other Vendor\n点击查看排行榜-端游 & 主机游戏',
    hoverEn: 'Data Source: Other Vendor\nClick to view Top Charts-PC&Console',
    sourceUrl: '/intelligence/topCharts/pcConsoleGames/MetricsTable',
  },
  {
    icon: appannie,
    nameEn: 'data.ai',
    hoverZh: '数据来源：data.ai\n点击查看排行榜-手游',
    hoverEn: 'Data Source: data.ai\nClick to view Top Charts-Mobile',
    sourceUrl:
      '/intelligence/topCharts/mobileGames?chart_type=bar&source=appannie&sort_name=dau&ratio_type=0&order=desc',
  },
  {
    icon: crunchbase,
    nameEn: 'Crunchbase',
    hoverZh: '数据来源：Crunchbase\n点击查看公司-收入',
    hoverEn: 'Data Source: Crunchbase\nClick to view Company Revenue',
    sourceUrl:
      '/intelligence/topCharts/companies/Revenue?chart_type=bar&sort_name=total_revenue&order=desc&ratio_type=0',
  },
  {
    icon: NPD,
    nameEn: 'NPD',
    hoverZh: '数据来源：NPD\n点击查看排行榜-端游',
    hoverEn: 'Data Source: NPD\nClick to view Top Charts-PC',
    sourceUrl: '/intelligence/topCharts/pcGames/PhysicalRevenue',
  },
  {
    icon: playstation,
    nameEn: 'PlayStation',
    hoverZh: '数据来源：PlayStation\n点击查看商店排行-主机游戏地区',
    hoverEn: 'Data Source: PlayStation\nClick to view Store Ranks-Console Region',
    sourceUrl: '/intelligence/storeRanks/ConsoleRegion/playstation',
  },
  {
    icon: nintendo,
    nameEn: 'Nintendo',
    hoverZh: '数据来源：Nintendo\n点击查看商店排行-主机游戏地区',
    hoverEn: 'Data Source: Nintendo\nClick to view Store Ranks-Console Region',
    sourceUrl: '/intelligence/storeRanks/ConsoleRegion/nintendo',
  },
  {
    icon: epic,
    nameEn: 'Epic',
    hoverZh: '数据来源：Epic Games Store\n点击查看商店排行-主机游戏地区',
    hoverEn: 'Data Source: Epic Games Store\nClick to view Store Ranks-Console Region',
    sourceUrl: '/intelligence/storeRanks/PCGlobal/epic',
  },
  {
    icon: hatchet,
    nameEn: 'Hatchet',
    hoverZh: '数据来源：Hatchet\n点击查看直播-游戏',
    hoverEn: 'Data Source: Hatchet\nClick to view Streaming',
    sourceUrl: '/intelligence/streaming/games?subTab=hoursWatched',
  },
  {
    icon: twitch,
    nameEn: 'Twitch',
    hoverZh: '数据来源：Twitch\n点击查看直播-游戏',
    hoverEn: 'Data Source: Twitch\nClick to view Streaming',
    sourceUrl: '/intelligence/streaming/influencer',
  },
  {
    icon: fbGaming,
    nameEn: 'FB Gaming',
    hoverZh: '数据来源：FB Gaming\n点击查看直播-游戏',
    hoverEn: 'Data Source: FB Gaming\nClick to view Streaming',
    sourceUrl: '/intelligence/streaming/influencer',
  },
  {
    icon: youtube,
    nameEn: 'YouTube',
    hoverZh: '数据来源：YouTube\n点击查看直播-游戏',
    hoverEn: 'Data Source: YouTube\nClick to view Streaming',
    sourceUrl: '/intelligence/streaming/influencer',
  },
];
